import { useTheme } from '../../contexts/ThemeContext';

function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  const { theme } = useTheme();
  
  return (
    <div style={{ marginBottom: '24px' }}>
      <h1 style={{ 
        color: theme.colors.textPrimary, 
        margin: 0,
        transition: 'color 0.3s ease'
      }}>
        {title}
      </h1>
      {subtitle && (
        <p style={{ 
          color: theme.colors.textSecondary, 
          marginTop: '6px',
          transition: 'color 0.3s ease'
        }}>
          {subtitle}
        </p>
      )}
    </div>
  )
}

export default PageHeader
